<div class="min-h-80vh pt-not-auth-header-m md:pt-not-auth-header-d">
  <ng-container *ngIf="currStepConfig$ | async as currStepConfig">
    <div>
      <h2
        class="text-center text-secondary font-semibold text-24px pt-50px md:pt-100px"
      >
        Sign Up
      </h2>

      <div class="px-app-x-m mt-40px relative">
        <div class="flex justify-center mt-40px max-w-450px mx-auto">
          <!-- <ib-spinner [diameter]="15"></ib-spinner> -->
        </div>

        <ib-sign-up-wizard-indicators
          [isCompanyAccount]="formS.isCompanyAccount"
          class="block mt-16px md:mt-24px max-w-450px mx-auto"
        ></ib-sign-up-wizard-indicators>

        <div class="mt-30px md:mt-40px max-w-450px pt-36p ml-auto mr-auto">
          <hr class="block md:hidden mt-16px my-16px border-border-d" />

          <div
            class="bg-white rounded-wdgt mt-12px md:shadow-wdgt p-0 md:px-24px md:pt-24px md:pb-36px md:pt-24px md:pb-24px"
          >
            <div
              *ngIf="
                currStepConfig.v.type !== STEPS.ADDRESS &&
                currStepConfig.v.type !== STEPS.START &&
                currStepConfig.v.type !== STEPS.DOCS &&
                currStepConfig.v.type !== STEPS.FINISH
              "
              class="mb-36px pt-16px text-center italic"
            >
              {{ currStepConfig.v.description | transloco }}
            </div>

            <ib-sign-up-steps
              class="max-w-450px block max-w-450px ml-auto mr-auto"
            ></ib-sign-up-steps>
          </div>
        </div>
        <ib-spinner
          *ngIf="isRegisterLoading$ | async"
          class="my-30px"
          [diameter]="30"
          [fluid]="true"
          class="bg-white z-10"
        ></ib-spinner>
      </div>
      <ib-sign-up-wizard-footer
        class="z-1000 flex fixed md:mt-60px bg-white h-100px md:h-auto md:max-w-450px md:pt-20px md:pb-70px px-app-x-m md:px-0 border-t md:border-t-0 border-border-d left-0 right-0 bottom-0 md:relative max-w-650px mx-auto justify-between items-center"
      ></ib-sign-up-wizard-footer>
    </div>
  </ng-container>
</div>

<ib-footer class="pb-100px md:pb-0 mt-70px"></ib-footer>

<!-- todo - replace to component and use with abstract class unsaved changes -->
<ng-template #modalTmpl>
  <div mat-dialog-content class="max-h-80vh p-0!">
    <div class="p-24px">Leaving this page will reset the wizard</div>
  </div>
  <div
    mat-dialog-actions
    class="border-t border-border-d flex justify-end items-center"
  >
    <div class="flex justify-end items-center grow">
      <button
        mat-button
        mat-dialog-close
        class="ib-btn-outline ib-btn-secondary mr-16px"
      >
        Cancel
      </button>
      <button mat-button [mat-dialog-close]="true" class="ib-btn-secondary">
        Yes, Leave
      </button>
    </div>
  </div>
</ng-template>
